<template>
  <div id="step_1">
    <img src="../img/band-size.png" style="max-width: 500px; width: 100%;">
    <div class="container">
      <h2>What's your band size?</h2>
      <p v-if="!$root.use_centimeters">
        To find your band size, grab a flexible measuring tape.
        If you don't have one, download and print one
        <a
                target="_blank"
                href="https://cdn.shopify.com/s/files/1/0088/8461/7274/files/printable-measuring-tape.pdf?12401468153346143080"
        >HERE</a>.
      </p>
      <p v-if="!$root.use_centimeters">
        Measure the snug measurement at the base of your breasts.
        Round up to the nearest half inch; i.e. if you measure 32.25 inches, round up to 32.5 inches.
      </p>
      <p v-else>
        Measure the snug measurement at the base of your breasts.
        Round up to the nearest half cm; i.e. if you measure 70.5" cm, round up to 71" cm.
      </p>
      <div class="form-group">
        <input
          v-if="!$root.use_centimeters"
          placeholder="put your inch measurement in here"
          type="number"
          class="form-control"
          min="25"
          max="54"
          step="0.5"
          required
          v-model.lazy="$root.underbust_size"
        >
        <input
          v-else
          placeholder="put your cm measurement in here"
          type="number"
          class="form-control"
          min="64"
          max="137"
          step="1"
          required
          v-model.lazy="$root.underbust_size"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toggleCentimeters() {
      const confirmed = confirm('This will delete your current measurements. Continue?');
      if (confirmed) {
        this.$root.use_centimeters = !this.$root.use_centimeters;
        this.$root.underbust_size = null;
        this.$root.cup_size = null;
        this.$root.shape = null;
        this.$root.waist_size = null;
        this.$root.hip_size = null;
        this.$root.type = 'bikini';
        this.$root.fit = 'normal';
      }
    },
  },
}
</script>

<style lang="less" scoped>
.kortni-jeane-fitting {
  .form-checkbox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .form-checkbox .checkbox {
    position: relative;
    width: 60px;
    height: 30px;

    margin-left: 6px;
    background-color: grey;
  }
  .form-checkbox .checkbox.active {
    background-color: black;
  }
  .form-checkbox .checkbox .slider {
    position: absolute;
    left: 3px;
    top: 3px;

    width: 24px;
    height: 24px;

    background-color: white;
  }
  .form-checkbox .active .slider {
    left: 33px;
  }
}
</style>
